<template>
  <div v-if="!hasChildren" class="filter-info" :data-filter-id="filter.id">
    <span uk-icon="icon: info; ratio: .8"></span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps({
    filter: {
      type: Object,
      required: true
    }
  })

  const hasChildren = computed(() => {
    return props.filter.children && props.filter.children.length > 0
  })
</script>

<style lang="scss" scoped>
  .filter-info {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
